/* eslint-disable no-console */
import { tap } from 'rxjs/operators/tap';
import { isObservable } from 'rxjs/util/isObservable';
import reduce from 'lodash.reduce';
import { LOGGING } from '../../../config/client.config';

// Utility operator for logging the intermediate results of a stream operation
const logger = (loggingKey) => (input, ...rest) => {
  if (!LOGGING) {
    return input;
  }

  if (isObservable(input)) {
    return input.pipe(
      tap((value) => console.log(`${loggingKey}:`, value, ...rest))
    );
  }

  return reduce(
    input,
    (res, val, key) => ({
      ...res,
      [key]: val.pipe(tap(() => console.log(`${loggingKey}:`, key, ...rest))),
    }),
    {}
  );
};

export default logger;
